<template>
    <transition name="confirm">
        <div v-if="show && animate" class="confirm">
            <div class="confirm-box">
                <div class="confirm-box-inner">
                    <!--标题-->
                    <div class="confirm-title" v-if="title">{{title}}</div>
                    <!--内容-->
                    <div class="confirm-content">{{content}}</div>
                </div>
                <!--按钮-->
                <div class="confirm-box-buttons">
                    <span class="confirm-btn-cancel" @click="_eventCancel">{{cancelText}}</span>
                    <span class="btn-line"></span>
                    <span class="confirm-btn-success" @click="_eventSuccess">{{submitText}}</span>
                </div>
            </div>
        </div>
    </transition>
</template>
<script scoped>
    export default {
        data () {
            return {
                name:'confirm',
                show: true,
                title: '',
                content: '',
                submitText: '确定',
                cancelText: '取消',
                success: null,
                cancel: null,
                animate: false
            }
        },
        mounted () {
            this.animate = true;
        },
        methods: {
            //确定按钮事件
            _eventSuccess () {
                this.show = false;
                this.success && this.success();
            },
            //取消按钮事件
            _eventCancel () {
                this.show = false;
                this.cancel && this.cancel();
            }
        }
    }
</script>
<style lang="scss" scoped>
    .confirm {
        background: rgba(00, 00, 00, .6);
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 19;
        text-align: center;
        .confirm-box {
            width: 600px;
            top: 50%;
            transform: translateY(-50%);
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            background: #fff;
            border-radius: 6px;
        }
        .confirm-box-inner{
            box-sizing: border-box;
            padding: 30px 20px;
        }
        .confirm-title {
            font-size: 32px;
            font-weight: bolder;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #333333;
            margin: 8px 0 10px 0;
        }
        .confirm-content {
            text-align: center;
            padding: 20px 0;
            line-height: 36px;
            color: #333333;
            font-size: 30px;
        }
        .confirm-box-buttons {
            background: #fafafa;
            height: 80px;
            width: 100%;
            border-top: 1px solid #ededed;
            text-align: center;
            display: flex;
            justify-content: center;
            border-radius: 0 0 6px 6px;
            overflow: hidden;
        }
        .confirm-btn-success {
            width: 45%;
            text-align: center;
            height: 80px;
            line-height: 80px;
            font-size: 30px;
            color: #333333;
        }
        .confirm-btn-cancel {
            width: 45%;
            text-align: center;
            height: 80px;
            line-height: 80px;
            font-size: 30px;
            color: #333333;
        }
        .btn-line{
            height: 100%;
            width: 2px;
            background: #ededed;
        }
    }

    .confirm-enter-active, .confirm-leave-active {
        transition: opacity .4s;
    }
    .confirm-enter, .confirm-leave-to{
        opacity: 0;
    }
</style>